import PurchaseMethodsService from 'commons-vehicle/PurchaseMethodsV25/services/PurchaseMethodsService/PurchaseMethodsServiceV25.js';
import PurchaseMethodsModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/PurchaseMethodsModelV25.js';
import { WindowProxy } from '@sm360/widget-commons-core-services';
import API_FETCH_STATUS from 'commons-vehicle/PurchaseMethodsV25/constants/apiFetchStatus.js';

import * as purchaseMethodsTypes from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionTypesV25.js';

export function loadPaymentOptionsMetadata(paymentOptionsMetadata) {
    return { type: purchaseMethodsTypes.LOAD_PURCHASE_METADATA_SUCCESS, paymentOptionsMetadata };
}

export function loadPurchaseMethodsSuccess(purchaseMethodsV25) {
    return {
        type: purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESSV25,
        purchaseMethodsV25,
    };
}

export function setPaymentOptionsFetchStatus(status) {
    return {
        type: purchaseMethodsTypes.SET_PAYMENT_OPTIONS_FETCH_STATUS,
        status,
    };
}

/**
 * Fetch paymentOptions data from desking paymentOptions endpoint and set in the store
 * @param [purchaseMethodsV25] Store object
 * @param [initialCall] boolean to indicate if its initial call for payment calculator
 * @param [config] config options to pass organization info
 * For initial call we send only specified params to API (Not to include financeOptions and other Finance related params)
 */
export function fetchAndSetPurchaseMethodsV25(purchaseMethodsV25, initialFetch = false, config) {
    return (dispatch) => {
        let purchaseMethodsData;
        if (initialFetch) {
            const {
                showroomVehicleId,
                vehicleCondition,
                cashDown,
                kmPerYearPlan,
                lien,
                odometer,
                paymentFrequency,
                purchaseMethod,
                saleType,
                taxPlan,
                term,
                tradeIn,
                transactionToken,
                financePlan,
            } = purchaseMethodsV25;
            purchaseMethodsData = {
                showroomVehicleId,
                vehicleCondition,
                cashDown,
                kmPerYearPlan,
                lien,
                odometer,
                paymentFrequency,
                purchaseMethod,
                saleType,
                taxPlan,
                term,
                tradeIn,
                transactionToken,
                financePlan,
            };
        } else {
            purchaseMethodsData = purchaseMethodsV25;
        }
        return PurchaseMethodsService.getPurchaseMethodsV25(purchaseMethodsData, config)
            .then((purchaseMethodsV25Data) => {
                purchaseMethodsV25Data.paymentOptionsFetchStatus = API_FETCH_STATUS.FETCHED;
                dispatch(loadPurchaseMethodsSuccess(new PurchaseMethodsModelV25(purchaseMethodsV25Data)));
            })
            .catch((error) => {
                throw error;
            });
    };
}

/**
 * Initial data for calculator load on VDP
 */

export function loadPurchaseMethodsV25() {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25, paymentOptionsMetadata } = state;
        const purchaseMethod = purchaseMethodsV25.getSelectedPurchaseMethodValue();
        let financePlan = '';

        if (Array.isArray(paymentOptionsMetadata)) {
            const leaseOption = paymentOptionsMetadata.find((opt) => opt?.purchaseMethod === 'lease');
            const financeOption = paymentOptionsMetadata.find((opt) => opt?.purchaseMethod === 'finance');

            if (purchaseMethod === 'lease' && leaseOption?.financePlan) {
                ({ financePlan } = leaseOption);
            } else if (purchaseMethod === 'finance' && financeOption?.financePlan) {
                ({ financePlan } = financeOption);
            }
        }

        dispatch(fetchAndSetPurchaseMethodsV25(purchaseMethodsV25.setIn(['financePlan'], financePlan), true));
    };
}

/**
 * selectPurchaseMethod - To switch purchase method in calculator
 * @param [purchaseMethod] Puchase method selected from option
 * @param [term] select the maximum term by default for Finance and Lease
 */
export function selectPurchaseMethod(
    purchaseMethod,
    term,
    paymentFrequency,
    kmPerYearPlan,
    cashDown,
    financePlan,
    config
) {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch(
            fetchAndSetPurchaseMethodsV25(
                purchaseMethodsV25
                    .set('purchaseMethod', purchaseMethod)
                    .set('term', term)
                    .set('paymentFrequency', paymentFrequency)
                    .set('kmPerYearPlan', kmPerYearPlan)
                    .set('cashDown', cashDown)
                    .set('financePlan', financePlan),
                false,
                config
            )
        );
    };
}

/**
 * selectTerm - To select term
 * @param [term] Payment term selected from list
 */

export function selectTerm(term, config) {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch(fetchAndSetPurchaseMethodsV25(purchaseMethodsV25.setIn(['term'], term), false, config));
    };
}

/**
 * selectPaymentFrequency - To select new payment frequency
 * @param [paymentFrequency] Payment frequency selected from dropdown
 */
export function selectPaymentFrequency(paymentFrequency, config) {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch(
            fetchAndSetPurchaseMethodsV25(
                purchaseMethodsV25.setIn(['paymentFrequency'], paymentFrequency?.value),
                false,
                config
            )
        );
    };
}

/**
 * setCashDown - To set Cash Down value
 * @param [cashDown] Cashdown input value
 */
export function setCashDown(cashDown, config) {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch(fetchAndSetPurchaseMethodsV25(purchaseMethodsV25.setIn(['cashDown'], cashDown), false, config));
    };
}

/**
 * setTradeIn - To set TradeIn value
 * @param [tradeIn] tradeIn input value
 */

export function setTradeIn(tradeIn, config) {
    return (dispatch, getState) => {
        const windowProxy = WindowProxy.get();
        if (windowProxy && windowProxy.localStorage) {
            windowProxy.localStorage.setItem('tradeIn', parseInt(tradeIn, 10));
        }
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch({ type: purchaseMethodsTypes.SET_TRADE_IN, tradeIn });
        dispatch(fetchAndSetPurchaseMethodsV25(purchaseMethodsV25.setIn(['tradeIn'], tradeIn), false, config));
    };
}
/**
 * setLien - To set Lien value
 * @param [lien] lien input value
 */

export function setLien(lien, config) {
    return (dispatch, getState) => {
        const windowProxy = WindowProxy.get();
        if (windowProxy && windowProxy.localStorage) {
            windowProxy.localStorage.setItem('lien', parseInt(lien, 10));
        }
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch({ type: purchaseMethodsTypes.SET_LIEN, lien });
        dispatch(fetchAndSetPurchaseMethodsV25(purchaseMethodsV25.setIn(['lien'], lien), false, config));
    };
}

/**
 * setTradeInAndLien - To set TradeIn AND Lien value
 * @param [tradeIn] tradeIn input value
 * @param [lien] lien input value
 */

export function setTradeInAndLien(tradeIn, lien, config) {
    return (dispatch, getState) => {
        const windowProxy = WindowProxy.get();
        if (windowProxy && windowProxy.localStorage) {
            windowProxy.localStorage.setItem('tradeIn', parseInt(tradeIn, 10));
            windowProxy.localStorage.setItem('lien', parseInt(lien, 10));
        }
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch({ type: purchaseMethodsTypes.SET_TRADE_IN, tradeIn });
        dispatch({ type: purchaseMethodsTypes.SET_LIEN, lien });
        dispatch(
            fetchAndSetPurchaseMethodsV25(
                purchaseMethodsV25.setIn(['tradeIn'], tradeIn).setIn(['lien'], lien),
                false,
                config
            )
        );
    };
}

export function setKMPlan(km, config) {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        dispatch(fetchAndSetPurchaseMethodsV25(purchaseMethodsV25.setIn(['kmPerYearPlan'], km?.value), false, config));
    };
}

/**
 * updateTargetPayment - To set the target payment value
 * @param [targetPayment] target payment input value
 */
export function updateTargetPayment(targetPayment, config) {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        const {
            transactionToken,
            saleType,
            taxPlan,
            purchaseMethod,
            vehicleCondition,
            term,
            paymentFrequency,
            tradeIn,
        } = purchaseMethodsV25;

        const targetPaymentPayLoad = {
            calculationTargetType: 'cashDown',
            calculationTargetValue: targetPayment,
            includeTaxes: false,
            purchaseMethod,
            saleType,
            taxPlan,
            transactionToken,
            vehicleCondition,
            term,
            tradeIn,
            paymentFrequency,
        };
        return PurchaseMethodsService.getPaymentRollV25(targetPaymentPayLoad, config)
            .then((paymentRollData) => {
                const { calculatedCashDown } = paymentRollData;
                dispatch(setCashDown(calculatedCashDown, config));
            })
            .catch((error) => {
                throw error;
            });
    };
}

export default {
    loadPaymentOptionsMetadata,
    loadPurchaseMethodsSuccess,
    selectPurchaseMethod,
    selectTerm,
    selectPaymentFrequency,
    setCashDown,
    setTradeIn,
    setLien,
    setTradeInAndLien,
    loadPurchaseMethodsV25,
    fetchAndSetPurchaseMethodsV25,
    updateTargetPayment,
    setPaymentOptionsFetchStatus,
    setKMPlan,
};
